import { Component, Input } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { GameType, GetMagicBlockResponse, MagicBlock, MagicSet } from "@apiserver-rest/ponder-data-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { take } from "rxjs";
import { MagicSetIconComponent } from "../set/magic-set-icon.component";
import { formatDate, shortenedName } from "@ponder-shared/utils/general";
import { intializeBaseSegmentArray } from "@ponder-features/header/navbar/navbar.component";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { NgClass, UpperCasePipe } from "@angular/common";
import { FormatNumberPipe } from "@ponder-shared/pipes/format-number.pipe";
import { NavigationService } from "@ponder-core/navigation/navigation.service";

@Component({
    imports: [LoadingComponent, MagicSetIconComponent, NgClass, UpperCasePipe, FormatNumberPipe],
    templateUrl: "./magic-block.component.html"
})
export class MagicBlockComponent {
    @Input() public blockCode!: string;

    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;

    public magicBlock?: MagicBlock;
    public childSets?: MagicSet[];
    public releaseDate?: string;
    public totalCards: number = 0;

    public allSelectedSets: string[] = [];

    constructor(private ponderDataClient: PonderDataClient, private pageTitle: Title, private events: EventBroker, private navigation: NavigationService) {
        this.sendNavbarUpdate();
    }

    public ngOnInit(): void {
        this.ponderDataClient
            .magicBlock(this.blockCode)
            .pipe(take(1))
            .subscribe({
                next: (response: GetMagicBlockResponse) => {
                    if (response.success && response.block) {
                        this.magicBlock = response.block;
                        this.childSets = response.children;
                        this.loadingSuccess = true;

                        this.pageTitle.setTitle(`Ponder > ${this.magicBlock.name} (${this.magicBlock.code!.toUpperCase()})`);

                        if (this.childSets) {
                            this.childSets.sort((a, b) => {
                                var aDate = a.releaseDate.getTime();
                                var bDate = b.releaseDate.getTime();
                                
                                if (aDate == bDate) {
                                    if (a.parentId && b.parentId) {
                                        return (b.cardCount! - a.cardCount!);
                                    } else if (a.parentId) {
                                        return 1;
                                    } else {
                                        return -1;
                                    }
                                } else {
                                    return aDate - bDate;
                                }
                            });

                            this.childSets.forEach(s => this.totalCards += s.cardCount!);
                            this.releaseDate = this.getReleaseDate(this.childSets[0].releaseDate);
                        }
                    }
                }
            })
            .add(() => this.isLoading = false );
    }
    
    private sendNavbarUpdate(): void {
        var segments = intializeBaseSegmentArray(GameType.Magic);
        this.events.ui.navbarUpdateEvent.emit(segments);
    }

    public getReleaseDate(releaseDate: Date): string | undefined {
        return formatDate(releaseDate);
    }

    public getTooltipName(name: string): string {
        return (name.length > 30 ? name : "");
    }

    public routeToSet(set: MagicSet): void {
        if (set) {
            this.navigation.goto(`/magic/set/${set.code}`);
        }
    }

    public onSetSelected(code: string): void {
        var index = this.allSelectedSets.indexOf(code);

        if (index >= 0) {
            this.allSelectedSets.splice(index, 1);
        } else {
            this.allSelectedSets.push(code);
        }
    }

    public onViewSelectedSets(): void {
        if (this.allSelectedSets.length == 0) {
            return;
        } else if (this.allSelectedSets.length == 1) {
            this.navigation.goto(`/magic/set/${this.allSelectedSets[0]}`);
        }
         else {
            this.navigation.goto("/search", { game: "Magic", set: this.allSelectedSets.join(',').toLowerCase() });
         }
    }
}